import React from "react";

export default function ProductIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0.25C9.07852 0.25 6.66617 2.42852 6.29849 5.25L5.63592 5.25C4.64023 5.24997 3.81454 5.24994 3.16653 5.34049C2.48529 5.43567 1.87316 5.64585 1.40763 6.16597C0.942096 6.68609 0.800806 7.31769 0.781433 8.00527C0.763004 8.65932 0.854212 9.47995 0.964197 10.4695L1.27209 13.2405C1.50212 15.3109 1.68278 16.937 1.98963 18.2008C2.30415 19.4962 2.77194 20.5072 3.64039 21.2845C4.50967 22.0625 5.57115 22.4154 6.90054 22.5847C8.19847 22.75 9.8466 22.75 11.9464 22.75H12.0535C14.1533 22.75 15.8015 22.75 17.0994 22.5847C18.4288 22.4154 19.4903 22.0625 20.3596 21.2845C21.228 20.5072 21.6958 19.4962 22.0103 18.2008C22.3172 16.937 22.4978 15.311 22.7278 13.2407L23.0358 10.4695C23.1457 9.47996 23.2369 8.65931 23.2185 8.00527C23.1991 7.31769 23.0579 6.68609 22.5923 6.16597C22.1268 5.64585 21.5147 5.43567 20.8334 5.34049C20.1854 5.24994 19.3597 5.24997 18.364 5.25L17.7015 5.25C17.3339 2.42858 14.9214 0.25 12 0.25ZM12 1.75C14.0913 1.75 15.8299 3.26063 16.184 5.25H7.81589C8.16998 3.26068 9.90869 1.75 12 1.75ZM6.53033 9.46967C6.23744 9.17678 5.76256 9.17678 5.46967 9.46967C5.17678 9.76256 5.17678 10.2374 5.46967 10.5303L6.06967 11.1303C9.3449 14.4056 14.6551 14.4056 17.9303 11.1303L18.5303 10.5303C18.8232 10.2374 18.8232 9.76256 18.5303 9.46967C18.2374 9.17678 17.7626 9.17678 17.4697 9.46967L16.8697 10.0697C14.1802 12.7591 9.81977 12.7591 7.13033 10.0697L6.53033 9.46967Z"
        fill="#A6B0CF"
      />
    </svg>
  );
}
